import { render, staticRenderFns } from "./SideDialogUserNew.vue?vue&type=template&id=05bae49e&scoped=true&"
import script from "./SideDialogUserNew.vue?vue&type=script&lang=js&"
export * from "./SideDialogUserNew.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogUserNew.vue?vue&type=style&index=0&id=05bae49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bae49e",
  null
  
)

component.options.__file = "SideDialogUserNew.vue"
export default component.exports